import * as React from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'app/rootReducer'
import {
  getEmptyAuthentication,
  setAuthentication
} from 'reducers/authentication/authenticationSlice'
import {
  getEmptyUserProfile,
  setUserProfile
} from 'reducers/userprofile/userprofileSlice'
import {
  getEmptyForgotPasswordData,
  setForgotPasswordData
} from 'reducers/forgotPassword/forgotpasswordSlice'
import {
  getInactiveActiveCase,
  setActiveCase
} from 'reducers/activecase/activecaseSlice'
import { clearActiveCourse } from 'reducers/activecourse/activecourseSlice'
import { useEffect } from 'react'

interface PrivateRouteProps extends RouteProps {
  // tslint:disable-next-line:no-any
  children: JSX.Element | JSX.Element[]
}

const PrivateRoute = (props: PrivateRouteProps): JSX.Element => {
  const dispatch = useDispatch()
  const authentication = useSelector((state: RootState) => state.authentication)
  const { children, ...rest } = props

  useEffect(() => {
    if (authentication.expirationTime) {
      const expiration = new Date(authentication.expirationTime)
      const now = new Date()
      if (expiration.getTime() < now.getTime()) {
        console.log('expired token')
        const authentication = getEmptyAuthentication()
        const userProfile = getEmptyUserProfile()
        const forgotPasswordData = getEmptyForgotPasswordData()
        const activeCase = getInactiveActiveCase()

        dispatch(setAuthentication(authentication))
        dispatch(setUserProfile(userProfile))
        dispatch(setForgotPasswordData(forgotPasswordData))
        dispatch(setActiveCase(activeCase))
        dispatch(clearActiveCourse())
      }
    }
  }, [authentication])

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        return authentication.isAuthenticated === true ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: routeProps.location }
            }}
          />
        )
      }}
    />
  )
}

export default PrivateRoute
